import { useContext } from "react";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IMassBillPaymentProps } from "entity/massPoPayment/MassBillPayment/MassBillPayment";

const MassBillPayment = lazyLoadComponent(() => import("./MassBillPayment"));
const UnifiedBillPayment = lazyLoadComponent(
    () => import("entity/unifiedBillPayment/UnifiedBillPayment/UnifiedBillPayment"),
);

/**
 * MassPoPayment wrapper that maintains the query string parameter as state variables so that we can safely remove
 * the query string parameters so as not to break relative routing
 */

export const MassBillPaymentRoute = (
    props: Omit<IMassBillPaymentProps, "history" | "location" | "match" | "isOnlinePayment">,
) => {
    const builderInfo = useContext(BuilderInfoContext);
    const useUnifiedDialog = builderInfo?.flags.massBillPayRedesign ?? false;

    return (
        <RouteRelative
            path={routes.bill.massPay}
            render={(routeProps) => {
                const isOnlinePayment = routeProps.match.params.isOnlinePayment === "true";
                const selectedJobId = parseInt(routeProps.match.params.selectedJobId);

                return useUnifiedDialog ? (
                    <UnifiedBillPayment
                        {...props}
                        {...routeProps}
                        isOnlinePayment={isOnlinePayment}
                        selectedJobId={selectedJobId}
                    />
                ) : (
                    <MassBillPayment
                        {...props}
                        {...routeProps}
                        isOnlinePayment={isOnlinePayment}
                        selectedJobId={selectedJobId}
                    />
                );
            }}
        />
    );
};
